import { SxProps, Theme } from "@mui/material";

import { DATETIME_FORMATS } from "@/common/constants/common";

import EntityChangedByInfoCardBase, { Entity } from "./EntityChangedByInfoCardBase";

export interface EntityChangedByInfoCardProps {
  entity: Entity | null | undefined;
  dateFormat?: string | null | undefined;
  sx?: SxProps<Theme>;
}

/** Shows who created the entity. */
export default function EntityChangedByInfoCard({
  entity,
  dateFormat = DATETIME_FORMATS.DISPLAY_DATETIME,
  sx,
}: EntityChangedByInfoCardProps) {
  const isUpdate = !!entity?.updatedAt && !!entity?.updatedBy;
  const datetime = isUpdate ? entity?.updatedAt : entity?.createdAt;
  const userId = isUpdate ? entity?.updatedBy : entity?.createdBy;

  if (!datetime && !userId) {
    return null;
  }

  return (
    <EntityChangedByInfoCardBase
      type={isUpdate ? "update" : "create"}
      dateFormat={dateFormat}
      datetime={datetime}
      userId={userId}
      sx={sx}
    />
  );
}
